import React from 'react';
import { TextField, type TextFieldProps } from '../../base-fields/TextField';
import { useFormField } from '../../../useFormField';
import type { StripControlledProperties } from '../../../types';

export const DashTextFormField = React.memo(function FormTextField(props: StripControlledProperties<TextFieldProps>) {
	const fieldProps = useFormField<string>(props);

	const onChange = (value: string) => {
		if (value === '' || value === '-') {
			fieldProps.onChange('-');
		} else {
			fieldProps.onChange(value);
		}
	};
	return (
		<TextField
			{...props}
			{...fieldProps}
			value={fieldProps.value !== '-' ? fieldProps.value : ''}
			type={props.type}
			onChange={onChange}
			onBlur={fieldProps.onBlur}
		/>
	);
});
